import React, { useState } from "react";
import { Link } from "react-router-dom";
import Input from "../Components/Input";
import Button from "../Components/Button";
import { forgotPassword } from "../Api/Password";

const RequestPasswordReset = () => {
  const [user, setUser] = useState({ email: "" });
  const [isFetching, setIsFetching] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setUser({ ...user, [name]: value });
  };

  const handleSubmit = (event) => {
    setIsFetching(true);
    event.preventDefault();
    forgotPassword(user.email);
  };

  const messageStyle = {
    color: "green",
    marginTop: "1rem",
  };

  return (
    <div className="flex justify-center h-full bg-white">
      <div className="w-1/2 flex items-center">
        <div className="flex flex-col items-stretch">
          <div className="mb-2">
            Forgot your password? Enter your email below and click submit to
            request a password reset.
          </div>
          <form id="submit" onSubmit={handleSubmit}>
            <Input
              type="email"
              label="Email"
              value={user.email}
              name="email"
              onChange={handleChange}
              disabled={isFetching}
              required
            />
            <div className="py-2"></div>
            {isFetching && (
              <div style={messageStyle}>
                Check your email for a link to reset your password
              </div>
            )}
            <Button
              text="Submit"
              type="submit"
              form="submit"
              value="Submit"
              disabled={isFetching}
              className="button button-lg"
            ></Button>
          </form>
          <Link to="/login" className="mt-3">
            I remember my password!
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;
